import { API } from "aws-amplify";
import { getProperty } from "~/graphql/queries";
import * as APITypes from "~/API";
import { PropertyLRUCache } from "~/services/cache/lruCache";

export const EMPTY_PROPERTY: APITypes.Property = {
  id: "",
  name: "",
  city: "",
  state: "",
  country: "",
  zipCode: "",
  poBox: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  // TODO: Clean up
  // pictures: [],
  description: "",
  areaSize: "",
  contact: "",
  expectedRentPaymentDate: "",
  __typename: "Property",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getPropertyDetails = async (
  propertyID: string,
  forceReload: boolean
) => {
  if (!forceReload) {
    const response = PropertyLRUCache.get(propertyID);
    console.log("loaded property from cache", response);
    if (response.success) {
      return response;
    }
  }

  try {
    const response = (await API.graphql({
      query: getProperty,
      variables: {
        id: propertyID,
      },
    })) as { data?: APITypes.GetPropertyQuery };

    // If property doesn't exist, return failure
    if (!response.data?.getProperty) {
      return {
        success: false,
        data: EMPTY_PROPERTY,
        error: new Error("Property not found"),
      };
    }

    const data = response.data.getProperty;

    const updatedCache = PropertyLRUCache.update({
      key: propertyID,
      value: data,
    });

    return {
      success: true,
      data: data,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_PROPERTY,
      error,
    };
  }
};
